import {commentMapper} from '../../mappers/comments/comment-mapper';
import {commentHttpRepository} from '../../repositories/comments-http-repository';
import {CommentsMemoryRepository} from '../../repositories/comments-memory-repository';

export const readArticleThreadComments = articleId => commentHttpRepository.get(articleId, {order: 'desc'})
  .then(comments => {
    CommentsMemoryRepository.setComments(comments.map(commentMapper.toDomain));

    return CommentsMemoryRepository.getComments();
  });
